import NODE_TYPES from "../constants/nodeTypes";

export default class RouteResponsePoint {
  /** @param {Object} data
   * @param {number} data.nodeTypes
   * @param {CityInfo} data.cityInfo
   * @param {GeoPoint} data.geoPoint
   * @param {RegionInfo} data.regionInfo
   * @param {CountryInfo} data.countryInfo
   */
  constructor({nodeTypes, cityInfo, geoPoint, regionInfo, countryInfo} = {}) {
    /** @type {number} */
    this.nodeTypes = nodeTypes;
    /** @type {GeoPoint} */
    this.geoPoint = geoPoint;
    // ========== Свойства только для десериализации ответа сервера ==========
    /** @type {CityInfo}
     * @private 
     */
    this.cityInfo = cityInfo;
    /** @type {RegionInfo} 
     * @private
     * */
    this.regionInfo = regionInfo;
    /** @type {CountryInfo} 
     * @private
     */
    this.countryInfo = countryInfo;
    // ========== /Свойства только для десериализации ответа сервера ==========

    // ========== Свойства для дальнейшего использования ==========
    /** @type {City} */
    this.city = undefined;
    /** @type {Region} */
    this.region = undefined;
    /** @type {Country} */
    this.country = undefined;
    // ========== /Свойства для дальнейшего использования ==========
  }

  /**
   * Является ли точка маршрута ключевой.
   * routePoint - точка маршрута из ответа сервера
   * @param {RouteResponsePoint} routeResponsePoint
   */
  static isKeyPoint = (routeResponsePoint) => {
    const keyPointMask = NODE_TYPES.start | NODE_TYPES.finish | NODE_TYPES.load | NODE_TYPES.unload | NODE_TYPES.passthrough;
    return (routeResponsePoint.nodeTypes & keyPointMask) !== 0;
  };

  /**
   * Является ли точка маршрута таможней.
   * routePoint - точка маршрута из ответа сервера
   * @param {RouteResponsePoint} routeResponsePoint
   */
  static isCustom = (routeResponsePoint) => {
    return (routeResponsePoint.nodeTypes & NODE_TYPES.custom) !== 0;
  };
}